import React, { useEffect, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Spinner,
} from "reactstrap";
import dayjs from "dayjs";

import { resourcesReports } from "../../../helpers/backend_helper";
import PreviewPDF from "../../../helpers/previewPDF";
import ButtonHelper from "../../../helpers/ButtonHelper";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import FormatDate from "../../../components/Common/FormatDate";
import FormatCurrency from "../../../components/Common/FormatCurrency";
import Calendar from "./Calendar";

const today = dayjs();

const FacturacionReport = ({ company_id = "", date = "", className = "" }) => {
  const [reportData, setReportData] = useState();
  const [pending, setPending] = useState(true);
  const [modal, setModal] = useState({ show: false });
  const [filters, setFilters] = useState({
    with_routes_summary: true,
    company_id,
    date: date || today.format("YYYY-MM"),
  });

  useEffect(() => {
    const config = {
      params: filters,
    };

    setPending(true);
    resourcesReports("show", config, `resellerReport`)
      .then((response) => {
        if (!response) return;

        setReportData(response);
      })
      .finally(() => {
        setPending(false);
      });
  }, [filters]);

  const getReports = (type) => {
    let config = {
      params: filters,
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };

    resourcesReports("show", config, `resellerReport`).then((response) => {
      if (type == 1) {
        console.log(response);
        const url = URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "ReporteFacturacion.xlsx");
        document.body.appendChild(link);
        link.click();
      } else {
        let nombre = "Archivo";
        var reader = new FileReader();
        reader.readAsDataURL(response);
        reader.fileName = nombre[1] || nombre[0];
        reader.onloadend = function (name) {
          name = nombre[0];
          var base64data = reader.result;
          setModal({ show: true, update: false, url: base64data });
        };
      }
    });
  };

  document.title = "Facturación|Reportes";

  if (pending)
    return (
      <div className="page-content">
        <div className=" text-center p-4">
          <Spinner />
        </div>
      </div>
    );

  if (!reportData)
    return (
      <div className="page-content">
        <div className=" text-center p-4">
          <p>No se encontro información</p>
        </div>
      </div>
    );

  return (
    <React.Fragment>
      <div className={className ? className : "page-content"}>
        <Container fluid>
          <Card>
            <CardHeader>
              <Breadcrumbs
                title={"Facturación"}
                breadcrumbItem={"Facturación"}
              />
            </CardHeader>
            <CardBody>
              <Row>
                <Col md={2} className="text-right pb-3">
                  {!date ? (
                    <div className="form-label mb-0">
                      <label>Seleccionar periodo</label>
                      <input
                        className="form-control"
                        type="month"
                        id="start"
                        name="start"
                        min="2023-01"
                        max={today.format("YYYY-MM")}
                        value={filters.date}
                        onChange={({ target }) => {
                          const date = target.value;

                          if (!date) return;

                          setFilters((prev) => ({
                            ...prev,
                            date,
                          }));
                        }}
                      />
                    </div>
                  ) : null}
                </Col>
                <Col md={10} className="text-right pb-3">
                  <ButtonHelper
                    addButon={false}
                    reportButons={true}
                    actionReportButon={getReports}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={8}>
                          <span className="text-muted mb-3 lh-1 d-block text-truncate">
                            Periodo
                          </span>
                          <h4 className="mb-3">
                            <FormatDate
                              format="MMM YYYY"
                              className="text-capitalize"
                              date={reportData.period}
                            />
                          </h4>
                        </Col>
                        <Col
                          md={4}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-calendar text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={10}>
                          <span className="text-muted mb-3 lh-1 d-block text-truncate">
                            Rutas
                          </span>
                          <h4 className="mb-3">{reportData.totalRoutes}</h4>
                        </Col>
                        <Col
                          md={2}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-road text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={10}>
                          <span className="text-muted mb-3 lh-1 d-block text-truncate">
                            Unidades activas
                          </span>
                          <h4 className="mb-3">
                            {reportData.totalUnidadesActivas}
                          </h4>
                        </Col>
                        <Col
                          md={2}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-bus text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col md={3}>
                  <Card>
                    <CardBody>
                      <Row>
                        <Col md={10}>
                          <span className="text-muted mb-3 lh-1 d-block text-truncate">
                            Costos
                          </span>
                          <h4 className="mb-3">
                            <FormatCurrency value={reportData.totalCosto} />
                          </h4>
                        </Col>
                        <Col
                          md={2}
                          className="text-center d-flex align-items-center justify-content-center"
                        >
                          <i
                            className="fa fa-money-bill text-primary"
                            style={{ fontSize: 20 }}
                          ></i>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Row>
                <Col md={12}>
                  <h4 className="mb-0 font-size-18">Resumen de rutas</h4>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md={12}>
                  <table className="table table-sm table-hover">
                    <thead>
                      <tr>
                        <th scope="col">Nombre de la ruta</th>
                        <th scope="col" className="text-center">
                          Unidades
                        </th>
                        <th scope="col" className="text-center">
                          Unidades activas
                        </th>
                        <th scope="col" className="text-end">
                          Costo
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.routesSummary.map((route) => (
                        <tr key={route.name}>
                          <td scope="row">{route.name}</td>
                          <td className="text-center">{route.totalUnidades}</td>
                          <td className="text-center">
                            {route.totalUnidadesActivas}
                          </td>
                          <td className="text-end">
                            <FormatCurrency value={route.costo} />
                          </td>
                        </tr>
                      ))}
                      {reportData.routesSummary?.length ? (
                        <tr>
                          <td scope="row">Total</td>
                          <td className="text-center fw-bold">
                            {reportData.totalUnidades}
                          </td>
                          <td className="text-center fw-bold">
                            {reportData.totalUnidadesActivas}
                          </td>
                          <td className="text-end fw-bold">
                            <FormatCurrency value={reportData.totalCosto} />
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan={4}>No se encontraron rutas</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardHeader>
              <Row>
                <Col md={12}>
                  <h4 className="mb-0 font-size-18">Resumen de unidades</h4>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              {!reportData.routesSummary?.length ? (
                <p>No se encontraron rutas</p>
              ) : null}
              {reportData.routesSummary.map((route) => (
                <div className="pb-4" key={route.name}>
                  <Row>
                    <Col md={12}>
                      <h4 className="mb-0 font-size-16 text-center py-2 bg-light">
                        Detalle: {route.name}
                      </h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <div className="table-responsive">
                        <table className="table table-sm table-hover">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col" className="text-center">
                                Unidad
                              </th>
                              <th scope="col" className="text-center">
                                Salidas
                              </th>
                              <th scope="col">Días de uso</th>
                              <th scope="col" className="text-end">
                                Total
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {route.routeUnidades.map((unidad) => (
                              <tr key={unidad.unit_id}>
                                <td scope="row">{unidad.unit_id}</td>
                                <td className="text-center">
                                  {unidad.unit_number}
                                </td>
                                <td className="text-center">
                                  {unidad.total_salidas}
                                </td>
                                <td className="text-center">
                                  <Calendar
                                    period={reportData.period}
                                    salidas={unidad.salidas}
                                  />
                                </td>
                                <td className="text-end">
                                  <FormatCurrency value={unidad.costo} />
                                </td>
                              </tr>
                            ))}
                            {route.routeUnidades.length === 0 ? (
                              <tr>
                                <td colSpan={5}>
                                  No se encontraron unidades disponibles para
                                  esta ruta
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                  </Row>
                </div>
              ))}
            </CardBody>
          </Card>
          {modal.show && <PreviewPDF modalPdf={modal} setModalPdf={setModal} />}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FacturacionReport;
